import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {TitleComponent} from '@/app/shared/components/title/title.component';
import {PartnerService} from '@services/partner.service';
import {Partner} from '@/app/core/models/partner';
import {MajorPartnerCardComponent} from '@components/partner-card/major-partner-card/major-partner-card.component';
import {ButtonComponent} from '@/app/shared/components/buttons/button/button.component';
import {DomSanitizer, SafeResourceUrl, Title} from '@angular/platform-browser';
import {environment} from '@/environments/environment';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {LastVideosComponent} from '@components/last-videos/last-videos.component';
import {MinorPartnerCardComponent} from '@components/partner-card/minor-partner-card/minor-partner-card.component';

@Component({
  selector: 'app-partners',
	imports: [
		TitleComponent,
		MajorPartnerCardComponent,
		ButtonComponent,
		TranslatePipe,
		LastVideosComponent,
		MinorPartnerCardComponent,
	],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './partners.component.html',
})
export class PartnersComponent implements OnInit {

	constructor(
		private readonly partnerService: PartnerService,
		private readonly sanitizer: DomSanitizer,
		private readonly titleService: Title,
		protected readonly translate: TranslateService
	) {	}

	majorPartners: Partner[] = [];
	minorPartners: Partner[] = [];
	video: string = 'CLIP_SPONSO.mp4';
	isPlaying = false;
	minioBaseUrl = environment.minioBaseUrl;
	embedUrl: SafeResourceUrl | undefined;

	ngOnInit(): void {
		this.loadPartners();
    }

	loadPartners(): void {
		this.partnerService.getPartners().subscribe({
			next: (partners) => {
				this.majorPartners = partners['MAJOR'] || [];
				this.minorPartners = partners['MINOR'] || [];
			},
			error: (error) => {
				console.error('Error fetching partners:', error);
			}
		});
	}

	toContactEmail() {
		const email = 'contact.teampeps@gmail.com\n';
		window.location.href = `mailto:${email}`;
	}

	play() {
		this.isPlaying = true;
		this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.minioBaseUrl + 'videos/' + this.video);
	}
}
